import { render, staticRenderFns } from "./insuranceCompanyInstructions.vue?vue&type=template&id=2baafc8a&scoped=true&"
import script from "./insuranceCompanyInstructions.vue?vue&type=script&lang=js&"
export * from "./insuranceCompanyInstructions.vue?vue&type=script&lang=js&"
import style0 from "./insuranceCompanyInstructions.vue?vue&type=style&index=0&id=2baafc8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baafc8a",
  null
  
)

export default component.exports